import React from "react";
import {
    PageHeaderElement,
    StyledPageHeader,
    StyledPageSubtitle,
    StyledPageTitle,
} from "./PageHeader.styles";
import { SHORT_NAME } from "../../../utils/info";

const PageHeader = ({ header }) => {
    return (
        <PageHeaderElement>
            <StyledPageHeader>
                <StyledPageTitle>{SHORT_NAME}</StyledPageTitle>
            </StyledPageHeader>
            <StyledPageSubtitle>{header}</StyledPageSubtitle>
        </PageHeaderElement>
    );
};

export default PageHeader;
